import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, onAuthStateChanged, User } from '@angular/fire/auth';
import { fromEventPattern, map, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const authGuard = (requireAuth: boolean): CanActivateFn => {
  return (route, state) => {
    const auth = inject(Auth);
    const router = inject(Router);
    const injector = inject(EnvironmentInjector);

    // Import this mandatory to have it initialized
    const authService = inject(AuthService);

    return fromEventPattern<User | null>(
      (handler) => runInInjectionContext(injector, () => onAuthStateChanged(auth, handler)),
      (handler, unsubscribe) => unsubscribe()
    ).pipe(
      take(1),
      map((user) => {
        const isAuthenticated = !!user;

        if (requireAuth && isAuthenticated) {
          return true;
        } else if (!requireAuth && !isAuthenticated) {
          return true;
        } else {
          console.log('Redirecting to', requireAuth ? '/login' : '/home');
          router.navigate(requireAuth ? ['/login'] : ['/home']);
          return false;
        }
      })
    );
  };
};
